export default {"src":"/_next/static/media/vitigni.f9a5e55a.svg","height":41,"width":38,"blurWidth":0,"blurHeight":0};